import { render } from "./AddCityZone.vue?vue&type=template&id=584e5390&ts=true"
import script from "./AddCityZone.vue?vue&type=script&lang=ts"
export * from "./AddCityZone.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__